import React, { useEffect, useRef } from 'react';
import { Message } from '../../../../interfaces/chat';
import ChatMessage from '../ChatMessage/ChatMessage';
import styles from './chatMessages.module.scss';
import { images } from '../../../../constants/images';
import Icon from '@mdi/react';
import { mdiAlertCircle } from '@mdi/js';

interface ChatMessagesProps {
    messages: Message[];
    isTyping: boolean;
    user?: any;
    onClose: () => void;
    onRefresh: () => void;
    disabled?: boolean;
    hasError?: boolean;
}

const ChatMessages: React.FC<ChatMessagesProps> = ({ messages, isTyping, user, onClose, onRefresh, disabled, hasError }) => {
    const messagesEndRef = useRef<HTMLDivElement>(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'auto' });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages, isTyping]);

    const renderWelcomeMessage = () => (
        <div className={styles.welcomeMessage}>
            <img
                src={images.linzeChat}
                alt="Linze IA"
            />
            <h4 className={styles.welcomeTitle}>¡Hola! Soy la IA de Linze</h4>
            <p className={styles.welcomeText}>
                Estoy aquí para ayudarte a encontrar el auto perfecto. ¿En qué puedo asistirte hoy?
            </p>
        </div>
    );

    const renderTypingIndicator = () => (
        <div className={styles.typingIndicator}>
            <div className={styles.typingDot}></div>
            <div className={styles.typingDot}></div>
            <div className={styles.typingDot}></div>
        </div>
    );

    return (
        <div className={styles.messagesContainer}>
            {messages.length === 0 && renderWelcomeMessage()}

            {messages.map((message, index) => (
                <ChatMessage key={message.id} message={message} user={user} onClose={onClose} onRefresh={onRefresh} isLastMessage={index === messages.length - 1} disabled={disabled} />
            ))}

            {hasError && (
                <div className={styles.errorBanner}>
                    <Icon path={mdiAlertCircle} size={0.7} color="#e53935" />
                    <span className={styles.errorBannerText}>Hubo un error al enviar</span>
                    <span className={styles.errorBannerSeparator}>-</span>
                    <button className={styles.errorBannerAction} onClick={onRefresh}>Reiniciar conversación</button>
                </div>
            )}

            {isTyping && renderTypingIndicator()}

            <div ref={messagesEndRef} />
        </div>
    );
};

export default ChatMessages;
